
import LookUp from "models/look-up";
export default {
  data() {
    return {
      // 默认应收抬头
      defaultAccountsReceivableHeaderList: [],
      // 默认应付抬头
      copingWithHeaderList: [],
      screen: {
        name: '',
        code: '',
        isOpen: 0
      },
      isOpenList: [
        { id: 0, name: '全部' },
        { id: 1, name: '已开启' },
        { id: 2, name: '已关闭' }
      ],
      isOpenObj: {
        0: null,
        1: true,
        2: false
      }
    }
  },
  created() {
  },
  methods: {
    // 获取默认应收抬头
    initDefaultAccountsReceivableHeaderList(hasDelete) {
      let data = {
        name: this.screen.name,
        code: this.screen.code,
        status: this.isOpenObj[this.screen.isOpen],
        hasDelete: hasDelete ? hasDelete:false
      }
      LookUp.getAccountsReceivableHeaderList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1;
            obj.name = value.name;
            obj.status = value.status;
            obj.isDelete = value.isDelete;
            obj.bankName = value.bankName;
            obj.bankAccount = value.bankAccount;
            obj.taxNumber = value.taxNumber;
            obj.code = value.code;
            obj.customizeName = `${value.code} ${value.name}`
            arr.push(obj);
          });
          this.defaultAccountsReceivableHeaderList = arr;
        }
      });
    },
    
    // 获取默认应付抬头
    initCopingWithHeaderList(hasDelete) {
      let data = {
        name: this.screen.name,
        code: this.screen.code,
        status: this.isOpenObj[this.screen.isOpen],
        hasDelete: hasDelete ? hasDelete : false
      }
      LookUp.getCopingWithHeaderList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1;
            obj.name = value.name;
            obj.status = value.status;
            obj.isDelete = value.isDelete;
            obj.bankName = value.bankName;
            obj.bankAccount = value.bankAccount;
            obj.taxNumber = value.taxNumber;
            obj.code = value.code;
            obj.customizeName = `${value.code} ${value.name}`
            arr.push(obj);
          });
          this.copingWithHeaderList = arr;
        }
      });
    }
  }
}